import * as React from 'react'
import { useObservable } from 'react-use'

import { useIsBrowser } from '@syconium/little-miss-figgy/dist/lib/hooks/useIsBrowser'
import { useIsViewport } from '@syconium/little-miss-figgy/dist/lib/hooks/useIsViewport'
import { ViewportSizes } from '@syconium/little-miss-figgy/dist/lib/hooks/useViewportBreakpoints'

import { useCartDialog } from '../../../../../app/_providers/CartProvider.client'
import {
  modalAnimationDuration,
  stickyAddToBagPortalClassName,
} from '../../../../../brunswick/styles/constants'
import { useShowStickyAddToBag } from '../../../../../lib/hooks/useShowStickyAddToBag'
// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-modal-react-modal-wrapper
import { NextModal } from '../../../../modals/NextModal'
import { NextModalStyles } from '../../../../modals/NextModal'

const styles: NextModalStyles = {
  content: {
    backgroundColor: 'white',
    border: 'none',
    borderRadius: 0,
    bottom: '0',
    boxSizing: 'border-box',
    left: '0',
    padding: '12px 24px',
    pointerEvents: 'all',
    right: '0',
    top: 'auto',
    transitionDuration: '0.4s',
    transitionProperty: 'opacity, transform',
    transitionTimingFunction: 'ease',
  },
  overlay: {
    background: 'none',
    pointerEvents: 'none',
    zIndex: 100,
  },
}

const STICKY_CART_VIEWPORTS = [ViewportSizes.small]

export const StickyAddToBagModal: React.FC<{
  children?: React.ReactNode
}> = ({ children }) => {
  const { isOpen: isCartDialogOpen } = useCartDialog()
  const isBrowser = useIsBrowser() === true
  const isValidStickyCartViewport = useIsViewport(STICKY_CART_VIEWPORTS)
  const showStickyAddToBag$ = useShowStickyAddToBag()
  const showStickyAddToBag = useObservable(showStickyAddToBag$, false)

  return (
    <NextModal
      closeTimeoutMS={modalAnimationDuration}
      portalClassName={stickyAddToBagPortalClassName}
      isOpen={!!showStickyAddToBag && !isCartDialogOpen && isBrowser && isValidStickyCartViewport}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      shouldFocusAfterRender={false}
      style={styles}
    >
      {children}
    </NextModal>
  )
}
